import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class DssActiveIcon extends BaseIcon {
    getChildren = () => {
        const color = this.getColor() === 'currentColor' ? '#2e3f58' : this.getColor()

        return [
            <g transform="translate(-59.667 -143)">
                <rect width="14" height="14" transform="translate(60 143)" fill="rgba(255,255,255,0.74)"/>
                <g transform="translate(-1244.91 -353.016)">
                    <g transform="translate(1305.609 497.878)">
                        <path d="M11.952,4.411a5.077,5.077,0,0,0-8.2,4V9.584" transform="translate(-2.478 -3.335)" fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"/>
                        <path d="M10,21.009a5.078,5.078,0,0,0,8.2-4V15.833" transform="translate(-6.774 -11.928)" fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"/>
                        <path d="M.526,20.833l1.272.781,1.421-.781" transform="translate(-0.526 -14.975)" fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"/>
                        <path d="M35.609,16.615l-1.324-.781-1.367.781" transform="translate(-22.858 -12.319)" fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"/>
                    </g>
                </g>
            </g>
        ]
    }
    getViewBox = () => '0 0 14.81 14'
}
